import React from 'react';

class Header extends React.Component {

    render() {
        return (
            <div>
                <div className="my-photo">
                    <img src="images/muneeb-shahid-new.png" alt="muneeb shahid" />
                    <div className="mask" />
                </div>
                <div className="site-title-block">
                    <h1 className="site-title">{this.props.siteTitle}</h1>
                    <p className="site-description">{this.props.siteDescription}</p>
                </div>
            </div>
        )
    }
}

export default Header